import axios from '../../utils/axiosConfig';

export const LOAD_PREFERENCES_REQUEST = 'LOAD_PREFERENCES_REQUEST';
export const LOAD_PREFERENCES_SUCCESS = 'LOAD_PREFERENCES_SUCCESS';
export const LOAD_PREFERENCES_FAIL = 'LOAD_PREFERENCES_FAIL';

export const SAVE_PREFERENCES_REQUEST = 'SAVE_PREFERENCES_REQUEST';
export const SAVE_PREFERENCES_SUCCESS = 'SAVE_PREFERENCES_SUCCESS';
export const SAVE_PREFERENCES_FAIL = 'SAVE_PREFERENCES_FAIL';

export const loadPreferences = () => async (dispatch, getState) => {
  dispatch({ type: LOAD_PREFERENCES_REQUEST });

  try {
    const { token } = getState().auth;
    const res = await axios.get('/user-settings', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({ type: LOAD_PREFERENCES_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch({
      type: LOAD_PREFERENCES_FAIL,
      payload: err.response?.data?.message || 'Failed to load preferences',
    });
  }
};

export const savePreferences = (newPrefs) => async (dispatch, getState) => {
  dispatch({ type: SAVE_PREFERENCES_REQUEST });

  try {
    const { token } = getState().auth;
    const res = await axios.put(
      '/user-settings',
      { preferences: newPrefs },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({ type: SAVE_PREFERENCES_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch({
      type: SAVE_PREFERENCES_FAIL,
      payload: err.response?.data?.message || 'Failed to save preferences',
    });
  }
};
